<!--
 @description 返回组件
 @author xiehan
 @date 2018/9/19
-->
<template>
	<div class="history-wrap">
		<div class="com-back">
			<span class="com-back__return" @click="backPrev">
				<i class="icon-tiaozhuan"></i>
				<span v-text="$t('component.back')"></span>
			</span>
			<div class="com-back__words">
				<div v-for="(item, index) in history" class="ilb" :key="'back' + index">
					<span v-show="index > 0">&nbsp; &gt;&nbsp;</span>
					<span class="com-back__words-text" 
					:class="{'com-back__words-text--clickable': (typeof history != 'undefined' && index < history.length - 1)}"
					v-text="item.name" 
					@click="backHistory(index)">
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'GBack',
  data () {
    return {

    }
  },
  props: ['history'],
  methods: {
    backPrev () {
      let index = this.history.length - 2 >= 0 ? this.history.length - 2 : 0
      this.backHistory(index, true)
      this.$emit('back', index)
    },
    backHistory (index, fromBack = false) {
      if (index === this.history.length - 1 && !fromBack) return
      this.$emit('back', index)
      if (index === 0 && !this.history[index].path) {
        let path = this.$route.path
        let parentPageName = path.split('/')[2]
        this.$router.push({
          path: `/home/${parentPageName}`
        })
      } else {
        this.$router.push({
          path: this.history[index].path
        })
      }
    }
  }
}
</script>

<style scoped>
	.history-wrap {
		margin-bottom: 15px;
		background: #FFFFFF;
	}
  .icon-tiaozhuan {
    transform: rotateY(180deg);
  }
	.com-back {
    padding: 5px 0;
    font-size: 14px;
    cursor: default;
	}
	.com-back__return {
    margin-right: 10px;
    color: #0B8DE5;
	}
	.com-back__return:hover {
    cursor: pointer;
    color: #3870b6;
    text-decoration: underline;
	}
	.com-back__words {
    padding-left: 10px;
    display: inline-block;
    border-left: 1px solid #ddd;
    color: #0B8DE5;
	}
	.com-back .com-back__words-text--clickable:hover {
    cursor: pointer;
    color: #3870b6;
    text-decoration: underline;
	}
	.com-back__words {
    padding-left: 10px;
    display: inline-block;
    border-left: 1px solid #ddd;
    color: #0B8DE5;
	}
	.ilb {
		display: inline-block;
	}
</style>